import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import EventEmitter from "./EventEmitter.js";
import Experience from "../Experience.js";
import gsap from "gsap";

export default class Resources extends EventEmitter {
  constructor(sources) {
    super();
    this.experience = new Experience();
    this.sources = sources;
    this.items = {};
    this.setLoaders();
  }

  setLoaders() {
    this.loaders = {};
    this.loadingManager = new THREE.LoadingManager();
    this.loaders.gltfLoader = new GLTFLoader(this.loadingManager);
    this.loaders.dracoLoader = new DRACOLoader();
    this.loaders.dracoLoader.setDecoderPath("draco/gltf/");
    this.loaders.gltfLoader.setDRACOLoader(this.loaders.dracoLoader);
    this.loaders.hdrEquirect = new RGBELoader();

    const loaderBar = document.querySelector(".loader");
    const filesRender = document.querySelector(".filesRender");
    this.loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
      const percent = Math.round((itemsLoaded / itemsTotal) * 100);
      filesRender.innerHTML = percent + " %";
      if (loaderBar) loaderBar.style.width = percent + "%";
    };
    this.loadingManager.onLoad = () => {
      gsap.to(".root", { opacity: 0, display: "none", delay: 2 });
    };
  }

  /**
   * Charge une ressource unique et enregistre le rÃŠsultat dans this.items
   * @param {Object} source
   * @returns {Promise}
   */
  loadResource(source) {
    return new Promise((resolve, reject) => {
      if (source.type === "gltfModel") {
        this.loaders.gltfLoader.load(
          source.path,
          (file) => {
            this.items[source.name] = file;
            // console.log(source.path, file);
            
            resolve(file);
          },
          undefined,
          (error) => reject(error)
        );
      } else if (source.type === "hdrFile") {
        this.loaders.hdrEquirect.load(
          source.path,
          (file) => {
            this.items[source.name] = file;
            resolve(file);
          },
          undefined,
          (error) => reject(error)
        );
      } else {
        // type non pris en charge
        resolve(null);
      }
    });
  }

  /**
   * Charge toutes les ressources appartenant Ã  une zone spÃŠcifique (ou zone commune)
   * @param {string} zone nom de la zone : "urbain", "peri", "rural" ou "common"
   * @returns {Promise}
   */
  loadZone(zone) {
    const sourcesToLoad = this.sources.filter(
      (s) => s.zone === zone || s.zone === "common"
    );
    return Promise.all(sourcesToLoad.map((s) => this.loadResource(s)));
  }

  /**
   * Charge uniquement les ressources communes (zone == "common")
   * @returns {Promise}
   */
  loadCommon() {
    return this.loadZone("common");
  }
}